// Mask field constants for input masking functionality
export const MASKED_FIELD_NAMES = ["phone", "postal", "zip"] as const;

export const FIELD_NAMES = {
  PHONE: "phone",
  POSTAL: "postal",
  ZIP: "zip",
} as const;

export const MASK_PATTERNS = {
  PHONE: "(000) 000-0000",
  POSTAL: "00000-0000",
  ZIP: "00000-0000",
} as const;

export type MaskedFieldName = (typeof MASKED_FIELD_NAMES)[number];
